import React, { useEffect, useState } from 'react'
import API from '../../services/api'
import { Toast } from '../../shared/Toast'
import { debounce } from '../../utils/Debounce'
import { SlButton, SlDrawer, SlIcon, SlInput } from '@shoelace-style/shoelace/dist/react'
import NoDataFound from '../../shared/NoDataFound'
import TableLoader from '../../shared/TableLoader'
import { formatDate } from '../../utils/dateFormat'
import { useForm, Controller } from 'react-hook-form'
import Select from 'react-select'
import {ScrollContainer} from 'react-indiana-drag-scroll';


function B2BContacts() {
    const [b2bContacts, setB2BContacts] = useState([])
    const [loader, setLoader] = useState(false)
    const [search, setSearch] = useState("")
    const [assign, setAssign] = useState(false)
    const [brandData, setBrandData] = useState([])
    const [formData, setFormData] = useState()
    const form1 = useForm()
    const handleSearch = (e) => {
        setSearch(e.target.value)
    }
    const handleAssign = (data) => {
        setAssign(true)
        fetchBrands()
        setFormData(data)
    }
    const handleCopy = (formData) => {
        formData = JSON.stringify(formData)
        window.navigator.clipboard
            .writeText(formData)
            .then(() => {
                Toast('success', "successfully copied");
            })
            .catch(() => {
                Toast('error', "something went wrong");
            });
    }
    const fetchB2BContacts = async () => {
        setLoader(true)
        try {
            let res = await API({
                url: '/sales_contacts/get_b2b_contacts',
                method: 'POST',
                responseType: 'json',
                data: {
                    search
                }
            })
            if (res.code === 200) {
                setB2BContacts(res.data)
            }
            else {
                Toast('error', res.data?.message)
            }
        } catch (error) {
            console.error(error)
        }
        finally {
            setLoader(false)
        }
    }
    function handleRequestClose(event) {
        if (event.detail.source === "overlay") {
            event.preventDefault();
        }
    }

    const fetchBrands = async () => {
        try {
            let res = await API({
                url: '/sales_contacts/get_brands',
                method: 'POST',
                responseType: 'json',
                data: {}
            })
            if (res.code === 200) {
                setBrandData(res.data)
            }
        } catch (error) {
            console.error(error)
        }
    }

    const assignContact = async (data) => {
        try {
            let res = await API({
                url: '/sales_contacts/assign_contact',
                method: 'POST',
                responseType: 'json',
                data: {
                    ...formData,
                    official_mobile: formData.mobile,
                    brand_id: data.brand.value,
                    date:undefined,
                }
            })
            if (res.code === 200) {
                Toast('success', "Assigned Successfully")
                setAssign(false)
                form1.reset()
            }
            else {
                Toast('error', res.data?.message)
            }
        } catch (error) {
            console.error(error)
        }
    }

    function handleClose() {
        setAssign(false)
        form1.reset()
    }
    useEffect(() => {
        fetchB2BContacts()
    }, [search])


    return (
        <>
            <div className='d-flex gap-3 justify-end mb-3'>
                <SlInput size='small' onSlInput={debounce(handleSearch, 500)} placeholder='Enter Company'></SlInput>
            </div>

            <ScrollContainer>
            <table className='table table-bordered'>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Client</th>
                        <th>Contact Name</th>
                        <th>Designation</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Created Date</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                {loader ? (
                    <TableLoader colspan={8} />
                ) : (
                    b2bContacts.length ? (
                        <tbody>
                            {b2bContacts.map((contact, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{contact.company}</td>
                                    <td>{contact.name}</td>
                                    <td>{contact.designation}</td>
                                    <td>
                                        <p>{contact.official_email}</p>
                                        <p>{contact.personal_email}</p>
                                    </td>
                                    <td>{contact.official_mobile}</td>
                                    <td>{formatDate(contact.date)}</td>
                                    <td>
                                        <div className='d-flex gap-3'>
                                            <sl-tooltip content="Assign Contact" >
                                                <SlIcon library='lucide' name='forward' className='cursor-pointer' onClick={() => handleAssign(contact)} />
                                            </sl-tooltip>
                                            <sl-tooltip content="Copy">
                                                <SlIcon library='lucide' name='copy' className='cursor-pointer' onClick={() => handleCopy(contact)} />
                                            </sl-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <NoDataFound colspan={8} />
                    )
                )}
            </table>
            </ScrollContainer>
            <SlDrawer open={assign} onSlAfterHide={handleClose} onSlRequestClose={handleRequestClose} label='Assign Contact'>
                <h5>Contact Details</h5>
                <div className='d-flex gap-2 mb-3'>
                    <div className='w-[120px]'>
                        <p className='d-flex justify-content-between mb-2'><span>Brand Name</span><span>:</span></p>
                        <p className='d-flex justify-content-between mb-2'><span>Contact Name</span><span>:</span></p>
                        <p className='d-flex justify-content-between mb-2'><span>Officail Mail</span><span>:</span></p>
                        <p className='d-flex justify-content-between mb-2'><span>Personal Email</span><span>:</span></p>
                        <p className='d-flex justify-content-between mb-2'><span>Mobile</span><span>:</span></p>
                        <p className='d-flex justify-content-between mb-2'><span>Designation</span><span>:</span></p>

                    </div>
                    <div>
                        <p className='mb-2'>{formData?.brand_name}</p>
                        <p className='mb-2'>{formData?.name}</p>
                        <p className='mb-2'>{formData?.official_email || "-"}</p>
                        <p className='mb-2'>{formData?.personal_email || "-"}</p>
                        <p className='mb-2'>{formData?.mobile || "-"}</p>
                        <p className='mb-2'>{formData?.designation || "-"}</p>

                    </div>
                </div>
                <hr></hr>
                <form className='mt-2' onSubmit={form1.handleSubmit(assignContact)}>
                    <div className='mb-3'>
                        <label>Choose Brand</label>
                        <Controller name='brand'
                            control={form1.control}
                            rules={{ required: true }}
                            render={({ field }) => (

                                <Select {...field} name='brand_' options={brandData}></Select>)}>
                        </Controller>
                        {form1.formState.errors?.brand && <p className='text-red-600'>Choose brand!</p>}
                    </div>
                    <div>
                        <SlButton variant='primary' type='submit' size='small' className='w-full'>Assign</SlButton>
                    </div>
                </form>
            </SlDrawer>
        </>
    )
}

export default B2BContacts